// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__s7Yrs","legacyBtn":"MutateMid_legacyBtn__2PskT"};